export const PATHS = {
  CHOOSE_LOCATION: 'choose-location',
  ANALYSE_REPORTS: 'analyse-reports',
  POINTS_NETWORK: 'points-network',
  ANALYSE: 'analyse',
  DATA_UPDATE_INFO: 'data-update-info',
  PDF: 'pdf',
}
